/* Le schede sotto una voce di menu: una riga di collegamenti e la pagina.
 *
 * Una scheda sola non si mostra come scheda: a chi fattura il Controllo ha
 * solo il cruscotto, e una barra con una voce sola sarebbe rumore.
 */

import type { ReactNode } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { TestaPagina } from "./TestaPagina";

export interface VoceScheda {
  percorso: string;
  nome: string;
  /** Quante cose aspettano in questa scheda. Vuoto: nessun numero. */
  conteggio?: number;
}

// Un solo elenco per le schede e le sottovoci del menu di Fatturare.
export const VISTE_FATTURARE = [
  { percorso: "da-fatturare", nome: "Da fatturare" },
  { percorso: "avvisi", nome: "Avvisi" },
  { percorso: "fatture-smart", nome: "Fatture Smart" },
  { percorso: "archivio", nome: "Archivio" },
] as const;

export function BarraSchede({ voci, base }: { voci: VoceScheda[]; base: string }) {
  if (voci.length < 2) return null;
  return (
    <nav className="schede" aria-label="Schede">
      {voci.map((v) => (
        <NavLink
          key={v.percorso}
          to={`${base}/${v.percorso}`}
          className={({ isActive }) => (isActive ? "corrente" : undefined)}
        >
          {v.nome}
          {v.conteggio !== undefined && v.conteggio > 0 && (
            <span className="conteggio">{v.conteggio}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

/** Il titolo della voce di menu, poi le schede, poi la pagina: lo stesso
 * ordine di Fatturare, che le schede se le disegna da se' per i conteggi. */
export function ConSchede({
  titolo,
  voci,
  base,
}: {
  titolo: string;
  voci: VoceScheda[];
  base: string;
}): ReactNode {
  return (
    <>
      <TestaPagina titolo={titolo} />
      <BarraSchede voci={voci} base={base} />
      <Outlet />
    </>
  );
}
